import { Box, Container, Stack, Tooltip, useMediaQuery } from "@mui/material";
import { withStyles } from "@mui/styles";
import React from "react";
import AccordionStake from "./AccordianStake";

export const LightTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#010E1E",
    color: "#ffffff",
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 0px 15px 5px",
    fontSize: 13,
    fontWeight: 400,
    padding: 20,
  },
}))(Tooltip);

export default function Staking() {
  return (
    <>
      <Box pb={10}>
        <Container maxWidth="lg">
          <AccordionStake />
        </Container>
      </Box>
    </>
  );
}
